import { noop } from "@tanstack/react-query"
import { createFileRoute, notFound, redirect } from "@tanstack/react-router"
import { requireChatPermission } from "@/entities/bottom-popup"
import { friendsQueryOptions } from "@/entities/friend"
import { SCENARIOS_TOTAL, scenarioQueryOptions } from "@/entities/scenario"
import { userQueryOptions } from "@/entities/user"
import { ScenarioProposePage } from "@/pages/scenario-propose"

export const Route = createFileRoute(
	"/_authenticated/friend/$friendId/scenario",
)({
	// Navigation can reuse a running preload, so the gate must never be skipped.
	preload: false,
	loader: {
		handler: async ({ context, params }) => {
			const friends = await context.queryClient.query({
				...friendsQueryOptions(context.userId),
				staleTime: "static",
			})
			const friend = friends.find(({ id }) => id === params.friendId)
			if (!friend) throw notFound()

			if (
				friend.scenarios?.proposal !== "none" ||
				(friend.scenarios?.played ?? 0) >= SCENARIOS_TOTAL
			) {
				throw redirect({
					to: "/board/friend/$friendId",
					params: { friendId: params.friendId },
					replace: true,
				})
			}

			void context.queryClient
				.query(scenarioQueryOptions(params.friendId))
				.catch(noop)

			const user = await context.queryClient.query({
				...userQueryOptions(context.userId),
				staleTime: "static",
			})
			const allowed = await requireChatPermission({
				queryClient: context.queryClient,
				user,
				friend,
			})
			if (!allowed) {
				throw redirect({
					to: "/friend/$friendId",
					params: { friendId: params.friendId },
					replace: true,
				})
			}

			return { friend }
		},
		staleReloadMode: "blocking",
	},
	component: ScenarioProposePageWrapper,
})

function ScenarioProposePageWrapper() {
	const { friend } = Route.useLoaderData()
	return <ScenarioProposePage friend={friend} />
}
